import { createSignal } from "solid-js";
import { Form, Row, Col } from "solid-bootstrap";
import { DeviceForm } from "./deviceform";

export function SoundOptions(props) {
    const [myDevice, setMyDevice] = createSignal(props.device);
    const [isMute, setIsMute] = createSignal(myDevice().is_muted);
    const [isMuteRange, setIsMuteRange] = createSignal(myDevice().is_mute_range);
    const readFormFields = (formDevice) => {
        formDevice["is_muted"] = formIsMute();
        formDevice["is_mute_range"] = !formIsMute() && formIsMuteRange();
        formDevice["mute_hour_start"] = formMuteStartHour();
        formDevice["mute_hour_end"] = formMuteEndHour();
    };

    function isDisplayMuteRangeOptions() {
        return !isMute() && isMuteRange();
    }
    function onChangeMute(e) {
        setIsMute(e.target.checked);
    }
    function onChangeMuteRange(e) {
        setIsMuteRange(e.target.checked);
    }
    function formIsMute() {
        const formIsMuteField = document.getElementById("device.is_muted");
        if (!formIsMuteField) {
            return false;
        }
        return formIsMuteField.checked;
    }
    function formIsMuteRange() {
        const formIsMuteRangeField = document.getElementById("device.is_mute_range");
        if (!formIsMuteRangeField) {
            return false;
        }
        return formIsMuteRangeField.checked;
    }
    function formMuteStartHour() {
        const formMuteStartHourField = document.getElementById("device.mute_hour_start");
        if (!formMuteStartHourField) {
            return 21;
        }
        return parseInt(formMuteStartHourField.value)
    }

    function formMuteEndHour() {
        const formMuteEndHourField = document.getElementById("device.mute_hour_end");
        if (!formMuteEndHourField) {
            return 9;
        }
        return parseInt(formMuteEndHourField.value);
    }

    return <DeviceForm title="Sound options" device={props.device} setDevice={setMyDevice} readFormFields={readFormFields} submitText="Save">
        <Row>
            <Col xs={12} md={3}>
                <Form.Check
                    type="switch"
                    id="device.is_muted"
                    label="Mute sounds"
                    onChange={onChangeMute}
                    checked={myDevice().is_muted}
                />

            </Col>
        </Row>
        <Show when={isMute()}>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Check
                        type="switch"
                        id="device.is_mute_range"
                        label="Mute during hours"
                        disabled
                        onChange={onChangeMuteRange}
                        checked={myDevice().is_mute_range}
                    />
                </Col>
            </Row>
        </Show>
        <Show when={!isMute()}>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Check
                        type="switch"
                        id="device.is_mute_range"
                        label="Mute during hours"
                        onChange={onChangeMuteRange}
                        checked={myDevice().is_mute_range}
                    />
                </Col>
            </Row>
        </Show>
        <Show when={isDisplayMuteRangeOptions()}>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Group>
                        <Form.Label>Mute start hour</Form.Label>
                        <Form.Select aria-label="Mute start hour" id="device.mute_hour_start" value={myDevice().mute_hour_start}>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Group>
                        <Form.Label>Mute end hour</Form.Label>
                        <Form.Select aria-label="Mute end hour" id="device.mute_hour_end" value={myDevice().mute_hour_end}>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
        </Show>
        <Show when={!isDisplayMuteRangeOptions()}>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Group>
                        <Form.Label>Mute start hour</Form.Label>
                        <Form.Select aria-label="Mute start hour" id="device.mute_hour_start" disabled value={myDevice().mute_hour_start}>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Group>
                        <Form.Label>Mute end hour</Form.Label>
                        <Form.Select aria-label="Mute end hour" id="mute_hour_end" disabled value={myDevice().mute_hour_end}>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
        </Show>
    </DeviceForm>;
}